// 修复 Chrome/Edge 最小化窗口被弹回的 Bug（Vue Router 导致）
if (typeof window !== 'undefined') {
  const userAgent = navigator.userAgent || '';
  if (userAgent.includes('Chrome') || userAgent.includes('Edg')) {
    const originalReplaceState = history.replaceState;
    history.replaceState = function (...args) {
      if (document.visibilityState === 'hidden') {
        return;
      }
      return originalReplaceState.apply(history, args);
    };
  }
}
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import App from './App.vue'
import router from './router'
import 'element-plus/dist/index.css'
import './assets/css/icon.css'
import ElementPlus from 'element-plus'
import ElTableInfiniteScroll from "el-table-infinite-scroll";
// 创建应用实例
const app = createApp(App)
const pinia = createPinia()  // 明确创建实例
// 安装插件
app.use(pinia)
app.use(router)
app.use(ElementPlus)
app.use(ElTableInfiniteScroll);
// 注册 Element Plus 图标组件
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 挂载应用
app.mount('#app')